import React from "react";
import ArtistWizardModal from "../../components/ArtistWizardModal.jsx";
import ArtistUpgradeModal from "../../billing/ArtistUpgradeModal.jsx";

// Renders the two modals that live at the "artist entry" seam:
//   1. ArtistWizardModal — the real profile wizard, shown when the user is
//      entitled (paid or still in trial).
//   2. ArtistUpgradeModal — paywall shown when the artist trial has expired
//      and they aren't subscribed.
//
// Both are controlled by flags on useLeftPanelState; the gate logic that
// decides which one opens lives in openArtistWizardGated() over there.
export default function ArtistWizardSection({
  showArtistWizard, setShowArtistWizard,
  shopProfile, onSubmitArtistProfile,
  showArtistUpgrade = false,
  setShowArtistUpgrade = () => {},
  artistTrialDaysLeft = 0,
  artistTrialStarted = false,
}) {
  return (
    <>
      {showArtistWizard && (
        <ArtistWizardModal
          open={showArtistWizard}
          onClose={() => setShowArtistWizard(false)}
          initialProfile={
            shopProfile
              ? {
                  displayName: shopProfile.display_name || shopProfile.name || "",
                  studioName: shopProfile.display_name || shopProfile.name || "",
                  tagline: shopProfile.tagline || "",
                  bio: shopProfile.bio || "",
                  city: shopProfile.city || "",
                  region: shopProfile.region || "",
                  country: shopProfile.country || "",
                  website: shopProfile.website_url || shopProfile.website || "",
                  instagram: shopProfile.instagram_url || shopProfile.instagram || "",
                  styleTags: shopProfile.style_tags || shopProfile.styles || [],
                  acceptPoolRequests: !!shopProfile.accept_pool_requests,
                  poolNotificationMode:
                    shopProfile.pool_notification_mode || "instant",
                  // Prefer the public-facing contact_email when set; fall
                  // back to the auth email so the field isn't blank for
                  // existing artists who pre-date the contact_email column.
                  contactEmail:
                    shopProfile.contact_email || shopProfile.email || "",
                  street: shopProfile.street || "",
                  postalCode: shopProfile.postal_code || "",
                  phone: shopProfile.phone || "",
                  hours: shopProfile.hours ?? "",
                }
              : null
          }
          onSubmitProfile={onSubmitArtistProfile}
        />
      )}

      <ArtistUpgradeModal
        open={showArtistUpgrade}
        onClose={() => setShowArtistUpgrade(false)}
        trialStarted={artistTrialStarted}
        artistTrialDaysLeft={artistTrialDaysLeft}
        reason="artist_profile"
      />
    </>
  );
}
